export enum SOURCE {
  android = 'android_sdk',
  ios = 'ios_sdk',
  web = 'web',
}

export const SOURCE_CONFIG: { [key in SOURCE]: string } = {
  [SOURCE.android]: 'Android',
  [SOURCE.ios]: 'iOS',
  [SOURCE.web]: 'Web',
};

export enum ALERTS {
  adware = 'Adware',
  ATO = 'ATO',
  botDetected = 'Bot Detected',
  cookieHijack = 'Cookie Hijack',
  deviceAnomalies = 'Device Anomalies',
  deviceSwitch = 'Device Switch',
  deviceTampering = 'Device Tampering',
  emulatorDevice = 'Emulator device',
  fastTraveler = 'Fast traveler',
  fraudsterBehavior = 'Fraudster Behavior',
  malware = 'Malware',
  mRATInstalled = 'mRAT Installed',
  networkAnomalies = 'Network Anomalies',
  oldDevice = 'Old device',
  pasteDetected = 'Paste Detected',
  RAT = 'RAT',
  riskyDevice = 'Risky Device',
  rootedDevice = 'Rooted device',
  screenScraping = 'Screen Scraping',
  sessionHijack = 'Session Hijack',
  sharedDevice = 'Shared Device',
  sharedDeviceVelocity = 'Shared Device Velocity',
  simultaneousLogin = 'Simultaneous Login',
  suspiciousBehavior = 'Suspicious Behavior',
  suspiciousNetwork = 'Suspicious Network',
  torConnection = 'Tor connection',
  unknownDevice = 'Unknown device',
  vpnConnection = 'VPN connection',
}

export const ALERT_TYPE: { [key in ALERTS]: string } = {
  [ALERTS.adware]: 'Adware',
  [ALERTS.ATO]: 'ATO (Account Take Over)',
  [ALERTS.botDetected]: 'Bot Detected',
  [ALERTS.cookieHijack]: 'Cookie Hijack',
  [ALERTS.deviceAnomalies]: 'Device Anomalies',
  [ALERTS.deviceSwitch]: 'Device Switch',
  [ALERTS.deviceTampering]: 'Device Tampering',
  [ALERTS.emulatorDevice]: 'Emulator device',
  [ALERTS.fastTraveler]: 'Fast traveler',
  [ALERTS.fraudsterBehavior]: 'Fraudster Behavior',
  [ALERTS.malware]: 'Malware',
  [ALERTS.mRATInstalled]: 'mRAT Installed',
  [ALERTS.networkAnomalies]: 'Network Anomalies',
  [ALERTS.oldDevice]: 'Old device',
  [ALERTS.pasteDetected]: 'Paste Detected',
  [ALERTS.RAT]: 'RAT (Remote Access Tool)',
  [ALERTS.riskyDevice]: 'Risky Device',
  [ALERTS.rootedDevice]: 'Rooted device',
  [ALERTS.screenScraping]: 'Screen Scraping',
  [ALERTS.sessionHijack]: 'Session Hijack',
  [ALERTS.sharedDevice]: 'Shared Device',
  [ALERTS.sharedDeviceVelocity]: 'Shared Device Velocity',
  [ALERTS.simultaneousLogin]: 'Simultaneous Login',
  [ALERTS.suspiciousBehavior]: 'Suspicious Behavior',
  [ALERTS.suspiciousNetwork]: 'Suspicious Network',
  [ALERTS.torConnection]: 'Tor connection',
  [ALERTS.unknownDevice]: 'Unknown device',
  [ALERTS.vpnConnection]: 'VPN connection',
};

export const Routes = {
  dashboard: '/dashboard',
  operations: '/operations',
};
